import { INPUT_STATE_ERROR } from '@yme/atoms/input';
export const hasInputError = (isError) => (isError ? INPUT_STATE_ERROR : undefined);
export const showErrorMessage = (isError, message) => isError ? message : undefined;
